export enum NoteNode {
    Note = 'yfm_note',
    NoteTitle = 'yfm_note_title',
    NoteContent = 'yfm_note_content',
}

export enum NoteAttrs {
    Class = 'class',
    Type = 'note-type',
    Line = 'data-line',
}
